import { render, staticRenderFns } from "./ListBlock.vue?vue&type=template&id=ed7fc8d0&scoped=true"
import script from "./ListBlock.vue?vue&type=script&lang=js"
export * from "./ListBlock.vue?vue&type=script&lang=js"
import style0 from "./ListBlock.vue?vue&type=style&index=0&id=ed7fc8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7fc8d0",
  null
  
)

export default component.exports